import axiosInstance from '../../../config/axiosInstance';
const AssetService = {
    async GetAllAssets(redirectCallback, ClientCompanyID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Asset/GetAllAssets?ClientID=${ClientID}&ClientCompanyID=${ClientCompanyID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async AllNewAssets(redirectCallback, ClientCompanyID, Start, PageSize, searchQuery, sortColumn, sortDirection,SearchColumns) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Asset/AllNewAssets?ClientID=${ClientID}&ClientCompanyID=${ClientCompanyID}&Start=${Start}&PageSize=${PageSize}&searchQuery=${searchQuery}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&UserID=${UserID}&SearchColumns=${SearchColumns}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetAssetCount(redirectCallback, ClientCompanyID, searchQuery,SearchColumns) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Asset/GetAssetCount?ClientID=${ClientID}&ClientCompanyID=${ClientCompanyID}&searchQuery=${searchQuery}&SearchColumns=${SearchColumns}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetAssetByID(redirectCallback, ID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Asset/GetAssetByID?ID=${ID}&ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteAsset(ID, redirectCallback) {
        try {
            const idString = ID.join(',');
            const response = await axiosInstance.get(`/Asset/DeleteAsset?ID=${idString}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async LockAsset(ID) {
        try {
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Asset/LockAsset?ID=${ID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async UnLockAsset(ID) {
        try {
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Asset/UnLockAsset?ID=${ID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async IsAssetCodeExist(ID, AssetCode) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Asset/IsAssetCodeExist?ID=${ID}&ClientID=${ClientID}&AssetCode=${AssetCode}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async WriteOff(ID, redirectCallback) {
        try {
            const idString = ID.join(',');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Asset/WriteOff?ID=${idString}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
     async DisabledWriteOff(ID, redirectCallback) {
        try {
            const idString = ID.join(',');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Asset/DisabledWriteOff?ID=${idString}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
};

export default AssetService;